import * as Http from "./Http.Client";

export const updateClientLocation = location => {
		return Http.Post('api/v1/update/client/location', {}, location, true)
				.then(result => result ? result : false);
};
